<template>
  <v-card class="hc__rounded-card">
    <v-navigation-drawer
      stateless
      value="true"
      height="auto"
      width="auto"
      class="hc__sidemenu"
    >
      <v-list>
        <v-list-group
          v-for="item in items"
          :key="item.id"
          :value="isActive(item.slug)"
          no-action
          class="hc__item-sidemenu"
        >
          <template v-slot:activator>
            <v-list-tile :class="{'hc__border-item-sidemenu' : isActive(item.slug)}">
              <v-list-tile-avatar size="20">
                <img :src="item.image">
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title :class="{'font-weight-bold': isActive(item.slug)}">
                  {{ item.name }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>

          <v-list-tile
            v-for="subcategory in item.subcategories"
            :key="subcategory.id"
            :to="`/centro-de-ayuda/${item.slug}/${subcategory.slug}`"
            v-if="subcategory.name != 'false'"
          >
            <v-list-tile-content>
              <v-list-tile-title class="ml-2">{{ subcategory.name }}</v-list-tile-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <!-- <v-icon>{{ subcategory.action }}</v-icon> -->
            </v-list-tile-action>
          </v-list-tile>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>
  </v-card>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      items: []
    }
  },
  computed: {

  },
  methods: {
    ...mapActions("helpcenter", ["fetchCategories"]),
    isActive(slug) {
      return this.$route.params.category === slug
    }
  },
  async created() {
    const res = await this.fetchCategories()
    let filter_categories = res.filter(category => category.hide_category == false);
    this.items = filter_categories
  }
}
</script>
<style lang="css">
.hc__item-sidemenu > .v-list__group__header > div > .theme--light.v-icon {
  color: #1FE8D9;
}

.hc__border-item-sidemenu {
  border-left: 3px solid #1FE8D9
}

.hc__sidemenu > .theme--light.v-list .v-list__group--active:before, .theme--light.v-list .v-list__group--active:after {
  background: rgba(0,0,0,0)
}
</style>